import { render, staticRenderFns } from "./ProFolderForm.vue?vue&type=template&id=d3697c7a&"
import script from "./ProFolderForm.vue?vue&type=script&lang=ts&"
export * from "./ProFolderForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports